import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/components/logo-marquee.tsx");
;
import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/components/sections/blog-posts.tsx");
;
import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/components/sections/faq.tsx");
;
import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/components/sections/features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/christophkranebitter/renehuemer.com/website/src/components/sections/hero.tsx");
;
import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/components/sections/in-reality.tsx");
;
import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/components/sections/value-proposition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/christophkranebitter/renehuemer.com/website/src/components/sections/video-section.tsx");
